const HIDDEN_TAG_IDS = new Set([
  '68fb38c33354b78bda63272b',
]);

const HIDDEN_FILTER_TAG_IDS = new Set([
  ...HIDDEN_TAG_IDS,
  '6a34d5633726ecd381da1f81',
]);

export function isHiddenTagId(tagId) {
  return HIDDEN_TAG_IDS.has(tagId);
}

export function isHiddenFilterTagId(tagId) {
  return HIDDEN_FILTER_TAG_IDS.has(tagId);
}

export function isHiddenTag(tag) {
  return isHiddenTagId(tag?.id || tag?.tagId || tag?.itemTagId);
}

export function isHiddenFilterTag(tag) {
  return isHiddenFilterTagId(tag?.id || tag?.tagId || tag?.itemTagId);
}
